import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function PendingEntry (){
  const {user} = useUser()
  let view = contentLayout[modules.PendingEntriesList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.PendingEntriesList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.PendingEntriesList}></Index>
 )
}

export default PendingEntry